{
  "lt-LT": {
    "model": {
      "profile": {
        "id": "Vartotojo ID.",
        "userName": "Vartotojo vardas",
        "email": "El. pašto adresas",
        "emailConfirmed": "El. pašto adresas patvirtintas.",
        "phoneNumber": "Telefono numeris",
        "phoneNumberConfirmed": "Telefono numeris patvirtintas.",
        "twoFactorEnabled": "Įjungta dviejų faktorių autentifikacija.",
        "lockoutEnd": "Blokavimo pabaiga",
        "lockoutEnabled": "Blokavimas įgalintas.",
        "accessFailedCount": "Nesėkmingų prisijungimų skaičius.",
        "firstName": "Vardas",
        "lastName": "Pavardė",
        "picture": "Profilio nuotrauka",
        "organisationName": "Organizacija",
        "name": "Vardas",
        "roles": "Vaidmenys"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Patvirtinta"
      },
      "action": {
        "resetPassword.tooltip": "Siųskite slaptažodžio atnaujinimo instrukcijas vartotojui el. paštu."
      },
      "message": {
        "resetPassword.success": "Vartotojui buvo išsiųstas el. laiškas su instrukcijomis, kaip atnaujinti slaptažodį."
      }
    }
  }
}